module.exports = __webpack_public_path__ + "img/bul_arr_up.1fe7ce51.svg";